module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-diff-selective-immo.3ec2bd5f.png";